import * as React from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { TapStates, queryClient, activeTabAtom, watchingPageAtom, eventTragetControl } from "../utils/states"
import cn from 'classnames';
import { shareURL } from '@telegram-apps/sdk';
import { useTransform, useMotionValue, animate, motion } from "motion/react";

function Dislike() {
    const [isAnimated, setAnimated] = React.useState(false);
    const xMotion = useMotionValue(0);

    const handleEventX = React.useCallback((e) => {
        if (eventTragetControl.state === TapStates.INTERRACTION) {
            let x = e.detail.delta_x;
            animate(xMotion, 4 * x / document.body.clientWidth, {delay: 0, duration: 0});
        }
    }, [xMotion]);

    const disCallback = React.useCallback(_ => {
        eventTragetControl.dispatchEvent(new CustomEvent("skip"));
    }, []);

    const handleStopIterraction = React.useCallback(_ => {
        animate(xMotion, 0, {delay: 0, duration: 0.3});
    }, [xMotion]);

    const handleSkip = React.useCallback(_ => {
        setAnimated(true);
        setTimeout(_ => setAnimated(false), 600);
    }, []);

    React.useEffect(() => {
        eventTragetControl.addEventListener("changeX", handleEventX);
        eventTragetControl.addEventListener("stopInterraction", handleStopIterraction);
        eventTragetControl.addEventListener("skip", handleSkip);
        return _ => {
            eventTragetControl.removeEventListener("changeX", handleEventX);
            eventTragetControl.removeEventListener("stopInterraction", handleStopIterraction);
            eventTragetControl.removeEventListener("skip", handleSkip);
        }
    }, [])

    const transitionValue = useTransform(xMotion, [-1, 0, 1], ["#0d0d0d", "#FF004F", "#FF004F"]);
    const borderValue = useTransform(xMotion, [-1, 0, 1], ["rgba(255, 255, 255, 0.05)", "rgba(255, 255, 255, 0.0)", "rgba(255, 255, 255, 0.0)"]);

    return (
        <motion.button onClick={disCallback} style={{
            background: transitionValue,
            borderColor: borderValue,
        }} className={cn('border rounded-full  p-4 text-white/90', isAnimated && 'animate-[skipbtn_0.5s_ease-out_1]')}>
            <svg width="24" height="24" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="fill-white/90" fillRule="evenodd" clipRule="evenodd" d="M21.0003 24.7133L30.2805 33.9936C30.773 34.486 31.4409 34.7627 32.1373 34.7627C32.8337 34.7627 33.5016 34.486 33.994 33.9936C34.4865 33.5011 34.7631 32.8332 34.7631 32.1368C34.7631 31.4404 34.4865 30.7725 33.994 30.2801L24.7103 20.9998L33.9923 11.7196C34.236 11.4757 34.4293 11.1863 34.5612 10.8678C34.693 10.5492 34.7608 10.2078 34.7608 9.86308C34.7607 9.51833 34.6927 9.17698 34.5607 8.8585C34.4287 8.54002 34.2352 8.25067 33.9914 8.00695C33.7476 7.76323 33.4581 7.56993 33.1396 7.43808C32.8211 7.30622 32.4797 7.2384 32.1349 7.23848C31.7902 7.23856 31.4488 7.30654 31.1303 7.43855C30.8119 7.57055 30.5225 7.76399 30.2788 8.00783L21.0003 17.2881L11.72 8.00783C11.478 7.757 11.1884 7.55689 10.8682 7.41917C10.5481 7.28144 10.2036 7.20887 9.85509 7.20568C9.50655 7.20248 9.16086 7.26874 8.8382 7.40057C8.51553 7.53241 8.22236 7.72719 7.97577 7.97354C7.72919 8.21989 7.53414 8.51288 7.402 8.83542C7.26986 9.15796 7.20328 9.50358 7.20614 9.85213C7.20901 10.2007 7.28126 10.5452 7.41868 10.8655C7.5561 11.1858 7.75594 11.4756 8.00653 11.7178L17.2903 20.9998L8.00828 30.2818C7.75769 30.5241 7.55785 30.8138 7.42043 31.1342C7.28301 31.4545 7.21076 31.799 7.20789 32.1475C7.20503 32.4961 7.27161 32.8417 7.40375 33.1642C7.53589 33.4868 7.73094 33.7798 7.97752 34.0261C8.22411 34.2725 8.51728 34.4672 8.83995 34.5991C9.16261 34.7309 9.5083 34.7972 9.85684 34.794C10.2054 34.7908 10.5498 34.7182 10.87 34.5805C11.1902 34.4428 11.4798 34.2427 11.7218 33.9918L21.0003 24.7133Z" fill="#FF5372" fillOpacity="0.9"/>
            </svg>
        </motion.button>
    )
}


function LikeVideo() {

    const [isAnimated, setAnimated] = React.useState(false);
    const xMotion = useMotionValue(0);

    const likeCallback = React.useCallback(_ => {
        eventTragetControl.dispatchEvent(new CustomEvent("like"));
    }, []);

    const handleEventX = React.useCallback((e) => {
        if (eventTragetControl.state === TapStates.INTERRACTION) {
            let x = e.detail.delta_x;
            animate(xMotion, 4 * x / document.body.clientWidth, {delay: 0, duration: 0});
        }
    }, [xMotion]);

    const handleStopIterraction = React.useCallback(_ => {
        animate(xMotion, 0, {delay: 0, duration: 0.3});
    }, [xMotion]);

    const handleLike = React.useCallback(_ => {
        setAnimated(true);
        setTimeout(_ => setAnimated(false), 600);
    }, []);

    React.useEffect(() => {
        eventTragetControl.addEventListener("changeX", handleEventX);
        eventTragetControl.addEventListener("stopInterraction", handleStopIterraction);
        eventTragetControl.addEventListener("like", handleLike);
        return _ => {
            eventTragetControl.removeEventListener("changeX", handleEventX);
            eventTragetControl.removeEventListener("stopInterraction", handleStopIterraction);
            eventTragetControl.removeEventListener("like", handleLike);
        }
    }, [])

   
    const transitionValue = useTransform(xMotion, [-1, 0, 1], ["#53FF95", "#53FF95", "#0d0d0d"]);
    const borderValue = useTransform(xMotion, [-1, 0, 1], ["rgba(255, 255, 255, 0.0)", "rgba(255, 255, 255, 0.0)", "rgba(255, 255, 255, 0.05)"]);
    const fillValue = useTransform(xMotion, [-1, 0.7, 1], ["rgba(0, 0, 0, 0.9)", "rgba(0, 0, 0, 0.9)", "rgba(255, 255, 255, 0.9)"]);

    return (
        <motion.button style={{
            background: transitionValue,
            borderColor: borderValue,
        }} onClick={likeCallback} className={cn('border rounded-full p-4', isAnimated && 'animate-[likebtn_0.5s_ease-out_1]')}>
            <svg width="24" height="24" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <motion.path style={{
                    fill: fillValue,
                }} d="M16.6214 10.1379C19.1064 6.80588 22.8427 5.83288 26.2797 6.76913C29.9897 7.77888 33.2517 10.9656 34.3349 15.4036C34.3909 15.6311 34.4393 15.8586 34.4802 16.0861C32.9164 15.5289 31.2155 15.486 29.6257 15.9636C27.3734 14.2976 24.5839 14.0176 22.1042 14.9311C18.9979 16.0774 16.5724 18.9841 16.0107 22.6416C15.2932 27.3246 18.1457 31.5316 22.1794 35.1086L22.8584 35.6966C22.3107 35.7351 21.7542 35.6494 21.2222 35.5356C20.9488 35.4768 20.6769 35.4115 20.4067 35.3396L19.4669 35.0771C11.1124 32.7269 5.51941 29.0501 3.91466 23.5551C2.63366 19.1696 3.86566 14.7789 6.57466 12.0489C9.08416 9.52013 12.8047 8.49463 16.6214 10.1379ZM19.4704 23.1719C20.2194 18.2859 25.8702 15.8779 28.7717 20.0709C28.7995 20.1099 28.8415 20.1363 28.8887 20.1445C28.9358 20.1527 28.9843 20.1419 29.0237 20.1146C33.1834 17.1676 37.6687 21.3624 36.7009 26.2099C36.1409 29.0215 33.5334 31.3549 28.8784 33.2099L28.1172 33.5074L27.6569 33.6964C27.2597 33.8521 26.8397 33.9764 26.4599 33.9099C26.0819 33.8434 25.7302 33.5809 25.4099 33.3009L24.8674 32.8109C20.8191 29.3272 19.0201 26.1142 19.4704 23.1719Z" fill="#53FF75" fillOpacity="0.9"/>
            </svg>
        </motion.button>
    )
}

function ShareButton() {
    const selectedPage = useAtomValue(watchingPageAtom);
    
    const shareCallback = _ => {
        const data = queryClient.getQueryData(['videos']);
        let totalIdx = 0;
        for (let pageIdx in data.pages) {
            for (let video in data.pages[pageIdx].videos) {
                if ((totalIdx + +video) === selectedPage) {
                    let videoItem = data.pages[pageIdx].videos[video];
                    shareURL(videoItem.share, 'Video from @' + videoItem.author.username);
                    try {
                        if (navigator.clipboard) {
                            navigator.clipboard.writeText(videoItem.share);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return;
                }
            }
            totalIdx += +data.pages[pageIdx].length;
        }
    };

    return (
        <button className='border border-white/5 rounded-full bg-white/5 p-4' onClick={shareCallback}>
            <svg className="mt-[-1px] mr-[-1px]" width="16" height="16" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.7499 6.54939L14.4539 11.1344L14.4247 11.7425L14.2935 11.7571C7.82137 12.5154 2.91699 18.0338 2.91699 24.7917C2.91699 25.4586 2.96658 26.1183 3.06574 26.7706C3.47262 29.4613 3.77887 29.7223 5.64991 27.4969C6.11384 26.9558 6.62108 26.4535 7.16658 25.9948C9.12511 24.3761 11.5606 23.4447 14.0995 23.3436L14.4291 23.3363L14.518 25.1286L14.7601 28.5483C14.8768 29.7208 16.1105 30.5215 17.2451 29.8813C17.7585 29.5925 18.2587 29.2833 18.7618 28.9771C21.3678 27.3467 23.8076 25.4727 26.1847 23.5258C27.5847 22.3592 28.8097 21.2538 29.8539 20.2475C30.3351 19.7765 30.8164 19.3054 31.2816 18.8183C31.9553 18.1125 32.0224 16.9444 31.3166 16.205C29.692 14.5061 27.3966 12.3783 24.5397 10.1208C22.2239 8.3096 19.8293 6.61793 17.2918 5.13189C16.0712 4.43626 14.8607 5.39001 14.7499 6.54939Z" fill="white" fillOpacity="0.9"/>
            </svg>
        </button>
    )
}


function BottomBar() {
    const tab = useAtomValue(activeTabAtom);

    if (tab === "language") {
        return null;
    }

    return (
        <nav className='relative h-[5em] bg-black flex flex-row justify-evenly items-center pb-2 flex-shrink-0'>
            <Dislike />
            <ShareButton />
            <LikeVideo />
        </nav>
    )
}

export default BottomBar;